import { render } from "./TotalAccountsPayableForTheCurrentMonth.vue?vue&type=template&id=79b908e6"
import script from "./TotalAccountsPayableForTheCurrentMonth.vue?vue&type=script&lang=js"
export * from "./TotalAccountsPayableForTheCurrentMonth.vue?vue&type=script&lang=js"

import exportComponent from "D:\\facturacion electronica\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__